// import React, { useState } from "react";

// import { Button, Flex, Form, Grid, Input, message, Spin, theme } from "antd";

// import {
//   ArrowRightOutlined,
//   LockOutlined,
//   SyncOutlined,
// } from "@ant-design/icons";
// import { Link, useNavigate, useSearchParams } from "react-router-dom";
// import { resetPassword } from "../Service/ressetPassword";

// const { useToken } = theme;
// const { useBreakpoint } = Grid;

// export default function ResetPassword() {
//   const [searchParams] = useSearchParams();

//   // Get the value of the 'token' query parameter
//   const reset_token = searchParams.get("token")?.replace(/'/g, "");
//   const [successMessage, setSuccessMessage] = useState(null);
//   const [status, setStatus] = useState(false);
//   const [messageApi, contextHolder] = message.useMessage();
//   const navigate = useNavigate();
//   const { token } = useToken();
//   const screens = useBreakpoint();

//   const [isLoading, setIsLoading] = useState(false);

//   const onFinish = (values) => {
//     setIsLoading(true);
//     resetPassword(values, {
//       headers: {
//         token: reset_token, // Pass token under the key 'token'
//       },
//     })
//       .then((res) => {
//         messageApi.open({
//         type: "success",
//         content: res.data.message,
//       });
//         setStatus(true);
//         setSuccessMessage(res.data.message);
//       })
//       .catch((err) => {
//         setStatus(false);
//         messageApi.open({
//         type: "error",
//         content: err.response.data.message,
//       });
//       })
//       .finally(() => {
//         setIsLoading(false);
//       });
//   };

//   const styles = {
//     container: {
//       backgroundColor: "rgba(240, 240, 240, 0.2)", // Transparent white with some opacity.
//       borderRadius: "10px",
//       backdropFilter: "blur(28px)", // Optional for visual effect.
//       padding: screens.md
//         ? `${token.paddingXL}px`
//         : `${token.sizeXXL}px ${token.padding}px`,
//       width: "auto", // Remove the fixed width for better flexibility.
//       alignSelf: "flex-end", // Align the `div` itself to the right if needed.
//       width: "350px",
//     },
//     footer: {
//       marginTop: token.marginLG,
//       textAlign: "center",
//       width: "100%",
//     },
//     forgotPassword: {
//       paddingTop: "10px",
//       float: "right",
//       color: "#4c5270",
//     },
//     header: {
//       marginBottom: token.marginXL,
//     },
//     section: {
//       backgroundColor: token.colorBgContainer,
//       display: "flex",
//       flexDirection: "column", // For vertical stacking; change to "row" if you want a horizontal layout.
//       justifyContent: "center", // Vertically centers items.
//       alignItems: "flex-end", // Aligns items horizontally to the right.
//       minHeight: "100vh", // Ensures full viewport height.
//       backgroundPosition: "center",
//       backgroundSize: "cover",
//       padding: screens.md ? `${token.sizeXXL}px 60px` : "10px",
//       width: "100%", // Ensures the section spans the full width.
//     },
//     text: {
//       color: "white",
//     },
//     title: {
//       fontSize: screens.md ? token.fontSizeHeading2 : token.fontSizeHeading3,
//     },
//   };

//   return (
//     <section
//       style={{
//         ...styles.section,
//         backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_page_image.png)`,
//       }}
//     >
//       {contextHolder}
//       <div
//         style={{
//           ...styles.container,
//         }}
//       >
//         <div
//           style={{
//             textAlign: "center",
//             paddingBottom: "1rem",
//             display: "flex",
//             width: "100%",
//             justifyContent: "center",
//             color: "white",
//           }}
//         >
//           <img
//             src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
//             alt="Logo"
//             style={{
//               width: "2rem",
//               height: "auto",
//               borderRadius: "50%",
//               marginRight: "10px",
//             }}
//           />
//           <h2>Step to Innovation</h2>
//         </div>
//         {status ? (
//           <>
//             <h1
//               style={{
//                 textAlign: "center",
//                 color: "#d3d5dfff",
//                 paddingBottom: "2rem",
//               }}
//             >
//               {successMessage}
//             </h1>
//             <Button
//               style={{
//                 background: "transparent",
//                 border: "none",
//                 padding: "5px",
//                 float: "right",
//                 marginTop: "10px",
//               }}
//               disabled={isLoading}
//             >
//               <Link
//                 to="/login"
//                 style={{
//                   float: "left",
//                   color: "#d3d5dfff",
//                 }}
//               >
//                 Login
//                 <ArrowRightOutlined
//                   style={{ paddingLeft: "3px", marginTop: "7px" }}
//                 />
//               </Link>
//             </Button>
//           </>
//         ) : (
//           <Form
//             name="normal_login"
//             initialValues={{
//               remember: true,
//             }}
//             onFinish={onFinish}
//             layout="vertical"
//             requiredMark="optional"
//           >
//             <Form.Item
//               name="newPassword"
//               label={
//                 <div style={{ color: "#d3d5dfff", fontWeight: "700" }}>
//                   NEW PASSWORD
//                 </div>
//               }
//               rules={[
//                 {
//                   required: true,
//                   message: "Please input your new password!",
//                 },
//               ]}
//             >
//               <Input.Password
//                 prefix={<LockOutlined />}
//                 type="password"
//                 placeholder="New Password"
//                 style={{ padding: "8px 12px" }}
//               />
//             </Form.Item>
//             <Form.Item
//               name="password"
//               label={
//                 <div style={{ color: "#d3d5dfff", fontWeight: "700" }}>
//                   CONFIRM PASSWORD
//                 </div>
//               }
//               rules={[
//                 {
//                   required: true,
//                   message: "Please input your confirm password!",
//                 },
//               ]}
//             >
//               <Input.Password
//                 prefix={<LockOutlined />}
//                 type="password"
//                 placeholder="Confirm Password"
//                 style={{ padding: "8px 12px" }}
//               />
//             </Form.Item>

//             <Form.Item style={{ marginBottom: "0px" }}>
//               <Button
//                 block="true"
//                 type="primary"
//                 htmlType="submit"
//                 style={{
//                   padding: "20px 12px",
//                   backgroundColor: isLoading ? "#1677ff" : undefined,
//                   borderColor: isLoading ? "#1677ff" : undefined,
//                   cursor: isLoading ? "not-allowed" : undefined,
//                 }}
//                 disabled={isLoading}
//                 icon={
//                   <Spin
//                     spinning={isLoading}
//                     indicator={<SyncOutlined spin />}
//                     // size="small"
//                     style={{ color: "white" }}
//                   />
//                 }
//               >
//                 {!isLoading ? "Reset" : ""}
//               </Button>
//             </Form.Item>
//             <Flex justify="end">
//               <Link
//                 to="/login"
//                 style={{
//                   float: "left",
//                   color: "#d3d5dfff",
//                 }}
//               >
//                 Login
//                 <ArrowRightOutlined
//                   style={{ paddingLeft: "3px", marginTop: "7px" }}
//                 />
//               </Link>
//             </Flex>
//           </Form>
//         )}
//       </div>
//     </section>
//   );
// }
import React, { useState } from "react";
import { Button, Form, Grid, Input, message, Spin, theme } from "antd";
import {
  ArrowRightOutlined,
  LockOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { resetPassword } from "../Service/ressetPassword";

const { useToken } = theme;
const { useBreakpoint } = Grid;

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const reset_token = searchParams.get("token")?.replace(/'/g, "");

  const [successMessage, setSuccessMessage] = useState(null);
  const [status, setStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();

  const { token } = useToken();
  const screens = useBreakpoint();

  const onFinish = (values) => {
    setIsLoading(true);
    resetPassword(values, {
      headers: { token: reset_token },
    })
      .then((res) => {
        messageApi.open({
          type: "success",
          content: res.data.message,
        });
        setStatus(true);
        setSuccessMessage(res.data.message);
      })
      .catch((err) => {
        setStatus(false);
        messageApi.open({
          type: "error",
          content: err.response?.data?.message || "Server error",
        });
      })
      .finally(() => setIsLoading(false));
  };

  /* 🔹 SAME STYLE SYSTEM AS LOGIN & FORGET PASSWORD */
  const styles = {
    section: {
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-end",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      padding: screens.md ? `${token.sizeXXL}px 60px` : "10px",
    },

    container: {
      background: "#ffffff",
      borderRadius: "12px",
      boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
      padding: "40px",
      width: "420px",
    },

    header: {
      textAlign: "center",
      marginBottom: "32px",
    },

    subtitle: {
      fontSize: "14px",
      color: "#718096",
    },

    label: {
      fontSize: "14px",
      fontWeight: 600,
      color: "#2d3748",
    },

    input: {
      padding: "12px 16px",
      borderRadius: "8px",
      fontSize: "16px",
    },

    button: {
      height: "48px",
      fontSize: "16px",
      fontWeight: 600,
      borderRadius: "8px",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      border: "none",
    },

    backToLogin: {
      marginTop: "16px",
      textAlign: "center",
      display: "block",
      color: "#667eea",
      fontSize: "14px",
      fontWeight: 500,
    },

    successText: {
      textAlign: "center",
      fontSize: "16px",
      color: "#2d3748",
      lineHeight: "1.6",
    },
  };

  return (
    <>
      {contextHolder}
      <section
        style={{
          ...styles.section,
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/home_page_image.png)`,
        }}
      >
        <div style={styles.container}>
          {/* Header */}
          <div style={styles.header}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
                alt="Logo"
                style={{
                  width: "5rem",
                  borderRadius: "50%",
                  marginRight: "10px",
                }}
              />
              <h2>Step to Innovation</h2>
            </div>
            <p style={styles.subtitle}>Set your new password</p>
          </div>

          {status ? (
            <>
              <p style={styles.successText}>{successMessage}</p>
              <Link to="/login" style={styles.backToLogin}>
                Back to Login <ArrowRightOutlined />
              </Link>
            </>
          ) : (
            <Form
              name="reset_password"
              layout="vertical"
              requiredMark={false}
              onFinish={onFinish}
            >
              <Form.Item
                name="newPassword"
                label={<span style={styles.label}>New Password</span>}
                rules={[
                  {
                    required: true,
                    message: "Please input your new password!",
                  },
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="New Password"
                  style={styles.input}
                />
              </Form.Item>

              <Form.Item
                name="password"
                label={<span style={styles.label}>Confirm Password</span>}
                rules={[
                  {
                    required: true,
                    message: "Please input your confirm password!",
                  },
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Confirm Password"
                  style={styles.input}
                />
              </Form.Item>

              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  block
                  type="primary"
                  htmlType="submit"
                  style={styles.button}
                  disabled={isLoading}
                  icon={
                    isLoading ? (
                      <Spin
                        indicator={<SyncOutlined spin />}
                        style={{ color: "white" }}
                      />
                    ) : null
                  }
                >
                  {!isLoading && "Reset Password"}
                </Button>
              </Form.Item>

              <Link to="/login" style={styles.backToLogin}>
                Back to Login <ArrowRightOutlined />
              </Link>
            </Form>
          )}
        </div>
      </section>
    </>
  );
}
